import { render, staticRenderFns } from "./add_academic_activity_dropdown.vue?vue&type=template&id=6743fb5c"
import script from "./add_academic_activity_dropdown.vue?vue&type=script&lang=js"
export * from "./add_academic_activity_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports